import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Password from "../Login/Password";
import "./Header.css";

const Header = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleLogout = () => setDropdownOpen((prevState) => !prevState);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const { isAuth, user } = useContext(AuthContext);
  const [modalPassword, setModalPassword] = useState(false);
  const togglePassword = () => setModalPassword(!modalPassword);

  return (
    <>
      {isAuth ? (
        <header className="sticky-top">
          <Navbar color="dark" dark expand="lg">
            <a href="/">
              <img
                src={"LogoSistemify2RS.png"}
                height="50 px"
                alt="logo"
              />
            </a>

            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
              {user.tipo == "Admin" ? (
                <>
                  <Nav className="mr-auto" navbar>
                    {/* Dashboard Principal */}
                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/">
                          🏠 DASHBOARD
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {/* Grid Bot */}
                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/Grid">
                          📊 GRID BOT
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {/* Solana Sniper */}
                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/sniper">
                          🐋 SNIPER
                        </NavLink>
                      </NavItem>
                    ) : undefined}
                    
                    {/* Futures Bot */}
                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/futures">
                          ⚡ FUTURES
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {/* Wallets */}
                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/wallets">
                          👛 WALLETS
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {/* Account Statement */}
                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/account">
                          📋 STATEMENT
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {/* Usuarios (Admin) */}
                    {user.menu_usuarios ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/ListadoUsuarios">
                          👥 USUARIOS
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {/* Admin Panel */}
                    {user.menu_admin ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/admin">
                          ⚙️ ADMIN
                        </NavLink>
                      </NavItem>
                    ) : undefined}
                  </Nav>
                </>
              ) : (
                <>
                  <Nav className="mr-auto" navbar>
                    {/* Dashboard para usuarios no admin */}
                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/">
                          🏠 DASHBOARD
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/Grid">
                          📊 GRID BOT
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/sniper">
                          🐋 SNIPER
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/futures">
                          ⚡ FUTURES
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/wallets">
                          👛 WALLETS
                        </NavLink>
                      </NavItem>
                    ) : undefined}

                    {user.dashboard ? (
                      <NavItem>
                        <NavLink className="titulosNav" href="/account">
                          📋 STATEMENT
                        </NavLink>
                      </NavItem>
                    ) : undefined}
                  </Nav>
                </>
              )}
              
              <NavbarText>
                <NavLink className="titulosNav">
                  <Dropdown direction="left" isOpen={dropdownOpen} toggle={toggleLogout}>
                    <DropdownToggle color="link">
                      <i className="fas fa-user-cog fa-2x"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem header>{user.nombre}</DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem onClick={togglePassword}>
                        🔑 Change Password
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem href="/logout">
                        🚪 Logout
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </NavLink>
              </NavbarText>
              
              <Modal size="sm" isOpen={modalPassword} toggle={togglePassword}>
                <ModalHeader toggle={togglePassword}>
                  <h4>Cambio de contraseña</h4>
                </ModalHeader>
                <ModalBody>
                  <Password />
                </ModalBody>
              </Modal>
            </Collapse>
          </Navbar>
        </header>
      ) : undefined}
    </>
  );
};

export default Header;
